// P2b tanda 7c (punto 2) — eje de variación CANÓNICO.
// La lista canónica es configurable en Configuración → Catálogo (endpoint
// /api/config/ejes-variacion); EJES_INICIALES es la semilla de una instalación
// nueva y el fallback si la config no responde. ⚠️ ESPEJO: la misma semilla
// vive en backend/services/systemSettings.js (CONFIG_DEFAULTS.ejesVariacion) —
// no comparten runtime, como los helpers de fecha (colTime).
export const EJES_INICIALES = ['Tono', 'Talla', 'Color', 'Tamaño'];

// Clave de comparación: minúsculas, espacios colapsados, sin tildes ni ñ
// (NFD deja la ñ como n + diacrítico combinante U+0300–U+036F y el replace
// lo quita: tamano ≡ tamaño).
const clave = (s) => String(s || '')
  .trim()
  .replace(/\s+/g, ' ')
  .toLowerCase()
  .normalize('NFD')
  .replace(/[̀-ͯ]/g, '');

// Singular naïf para el match (tonos→tono, colores→color). Solo para COMPARAR:
// el nombre que se devuelve es siempre el canónico con su ortografía.
const singular = (s) => {
  if (s.endsWith('es') && s.length > 4) return s.slice(0, -2);
  if (s.endsWith('s') && s.length > 3) return s.slice(0, -1);
  return s;
};

// normalizarEje(nombre, canonicos) → { nombre, reconocido, corregido }.
// Matchea ignorando mayúsculas, espacios, singular/plural y tildes/ñ; si
// reconoce, devuelve el canónico con su ortografía correcta. Si no reconoce,
// devuelve el nombre TAL CUAL (nunca inventa pertenencia) con reconocido:false.
export function normalizarEje(nombre, canonicos = EJES_INICIALES) {
  const original = String(nombre || '').trim();
  const k = singular(clave(original));
  for (const canonico of canonicos) {
    if (singular(clave(canonico)) === k) {
      return { nombre: canonico, reconocido: true, corregido: canonico !== original };
    }
  }
  return { nombre: original, reconocido: false, corregido: false };
}
